/*
 * @Author: lishiqiao
 * @Date: 2021-12-22 09:52:28
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-01-05 11:55:48
 */
export const constantRoutes = [{
        path: '/home',
        name: 'home',
        component: () =>
            import("../../views/pc/home.vue"),
        meta: {
            title: '首页'
        },
    },
    {
        path: "/content",
        name: "content",
        component: () =>
            import( /* webpackChunkName: "content" */ "../../views/pc/container.vue"),
        redirect: '/content/case',
        children: [{
                path: "/product",
                name: "product",
                component: () => import("../../views/pc/product.vue"),
                meta: {
                    title: '产品与服务'
                },
            },
            {
                path: "/case",
                name: "case",
                component: () => import("../../views/pc/case/case.vue"),
                meta: {
                    title: '客户案例'
                },
            },
            {
                path: "/case-details",
                name: "case_details",
                component: () => import("../../views/pc/case/case-details/case-details.vue"),
            },
            {
                path: "/news",
                name: "news",
                component: () => import("../../views/pc/news.vue"),
                meta: {
                    title: '行业新闻'
                },
            },
            {
                path: "/videohub",
                name: "videohub",
                component: () =>
                    import("../../views/pc/videohub.vue"),
                meta: {
                    title: '视频展示'
                },
            },
            {
                path: "/aboutus",
                name: "aboutus",
                component: () => import("../../views/pc/aboutus.vue"),
                meta: {
                    title: '关于我们'
                },
            },
            {
                path: "/contactus",
                name: "contactus",
                component: () => import("../../views/pc/contactus.vue"),
                meta: {
                    title: '联系我们'
                },
            },
            {
                path: "/privacy-policy",
                name: "privacy-policy",
                component: () => import("../../views/pc/privacy-policy.vue"),
                meta: {
                    title: '隐私政策'
                },
            }
        ]
    }

];